import { isAxiosError } from "axios";

/**
 * True when the call never got an HTTP response (offline, DNS, timeout, CORS).
 * A 4xx/5xx is a server answer and is not a network failure.
 */
export const isAxiosNetworkFailure = (error: unknown): boolean => {
  if (!isAxiosError(error)) return false;
  return error.response == null;
};
